import { render, staticRenderFns } from "./newcoupon.vue?vue&type=template&id=a70ffe40&scoped=true"
import script from "./newcoupon.vue?vue&type=script&lang=js"
export * from "./newcoupon.vue?vue&type=script&lang=js"
import style0 from "./newcoupon.vue?vue&type=style&index=0&id=a70ffe40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ffe40",
  null
  
)

export default component.exports